export default {
  productQuantity: [],
  products: {},
  mallType: 7,
};
